import { useFormik } from 'formik';
import {
	SignInFormValues,
	SignInSchema,
	toast,
	SignIn as View,
} from 'ui-components';
import { tryCatch } from 'utils';

import { useSignIn } from '~auth/queries/useSignIn';

export const SignIn = () => {
	const signIn = useSignIn();
	const form = useFormik<SignInFormValues>({
		initialValues: {
			email: '',
			password: '',
		},
		validationSchema: SignInSchema,
		onSubmit: (values, helpers) => {
			toast.promise(
				async () => {
					const [error, response] = await tryCatch(signIn.mutateAsync(values));
					if (error) {
						helpers.setSubmitting(false);
						throw error;
					}

					const responseBody = await response.json();

					if (response.status === 200) {
						window.location.href = responseBody.redirect_url ?? '/maps';
						toast.loading('Redirecting...');
						return;
					}

					if (responseBody.redirect_url) {
						window.location.href = responseBody.redirect_url;
					}
					toast.error(responseBody.message ?? 'Something went wrong!');
				},
				{
					loading: 'Signing you in...',
					error: (e) => e.message || 'Something went wrong!',
				}
			);
		},
	});

	return <View form={form} />;
};
